<template>
    <div>
        <div class="form-horizontal">

            <form-input :form="form" property="url"></form-input>

            <form-input :form="form" property="category">
                <select v-model="form.category" class="form-control">
                    <option v-for="category in categories" :value="category">{{category}}</option>
                </select>
            </form-input>

            <form-input :form="form" property="author"></form-input>

            <form-input :form="form" property="text">
                <textarea v-model="form.text" class="form-control" cols="10" rows="5"></textarea>
            </form-input>

            <form-input v-if="form.category == 'facebook'" :form="form" property="facebook_like"></form-input>
            <form-input v-if="form.category == 'facebook'" :form="form" property="facebook_love">
                <input type="checkbox" v-model="form.facebook_love">
            </form-input>

            <form-input v-if="form.category == 'facebook'" :form="form" property="monthly">
                <input type="checkbox" v-model="form.monthly">
            </form-input>

            <form-input v-if="form.category == 'producthunt'" :form="form" property="producthunt_like">
                <input type="checkbox" v-model="form.producthunt_like">
            </form-input>

            <form-input :form="form" property="featured">
                <input type="checkbox" v-model="form.featured">
            </form-input>

            <form-input :form="form" property="posted_at">
                <datepicker v-model="form.posted_at" input-class="form-control" />
            </form-input>

            <form-input :form="form" property="image" label="Photo">
                <photo-upload @input="files.image = $event" :value="form.image.url" @clear="files.image = null; form.image = {url: ''}"></photo-upload>
            </form-input>
        </div>
    </div>
</template>


<script>
import Model from 'lib/Model';
import Form from 'lib/Form';
import UploadFiles from 'lib/UploadFiles';

export default {
    mixins: [Model, UploadFiles],
    data() {
        return {
            active: 'form',
            method: '/api/testimonials',
            propertiesConfig: Spark.properties,
            form: new Form(() => {
                return {
                    url: null,
                    author: null,
                    category: null,
                    text: null,
                    facebook_like: 0,
                    facebook_love: false,
                    monthly: false,
                    posted_at:null,
                    producthunt_like: false,
                    featured: false,
                    image: {
                        alt: {}
                    },

                };
            }),
            categories: [
                'producthunt',
                'facebook',
            ]
        };
    },
    methods: {
        toggleActive(lang) {
            this.form.active[lang] = !this.form.active[lang];
        },

        copyTitle(lang) {
            this.form.image.alt = Object.assign({}, this.form.image.alt, {
                [lang]: this.form.title[lang]
            });
        },
        toggle(object, collection, newValue) {
            if (object[collection].find(x => x.id === newValue.id)) {
                object[collection] = object[collection].filter(x => x.id !== newValue.id);
            }
            else {
                object[collection].push(newValue);
            }
        }
    },
    watch: {

    },
    computed: {

    },
    mounted() {
        this.$on('input', () => {
            if (this.$refs.activityLog) {
                this.$refs.activityLog.load();
            }
        });
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/forms/testimonials/Testimonial.vue